"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationEventStatus = void 0;
const base_model_1 = require("../../base-model");
const certification_event_status_schema_1 = require("./certification-event-status.schema");
class CertificationEventStatus extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return certification_event_status_schema_1.certificationEventStatusSchema;
    }
}
exports.CertificationEventStatus = CertificationEventStatus;
